export const ERROR_MESSAGE_TYPE_BOARD_PERMSSIONS = 'boardPermissions'



// WEBPACK FOOTER //
// ./src/constants/errorMessageTypes.js